import type { ReactNode } from "react";

export interface SearchResultNestProps {
	children: ReactNode;
}

export const SearchResultNest = (props: SearchResultNestProps) => {
	const { children } = props;

	return <div className="ml-2.5 border-l-[1px] border-secondary-border pl-1">{children}</div>;
};
